var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRightFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=caret-right-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1399 8.75255L6.6585 13.5488C6.01192 14.1145 5 13.6554 5 12.7962L5 3.20375C5 2.34459 6.01192 1.88541 6.6585 2.45117L12.1399 7.2474C12.5952 7.64581 12.5952 8.35414 12.1399 8.75255Z",
    fill: "#343A40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRightFill);
export default __webpack_public_path__ + "static/media/caret-right-fill.9ee8d03655274425a1a34d82f34602f3.svg";
export { ForwardRef as ReactComponent };